import { resolveAvatarImageUrl } from './avatarInitials';

/**
 * Ảnh đại diện người gửi tin chat — đồng bộ với ChatMemberResource (thumbnail / avatar_url / avatar).
 * Trả null nếu không có ảnh thật (để UI dùng avatar chữ).
 * @param {Record<string, unknown>|null|undefined} sender
 * @returns {string|null}
 */
export function chatSenderThumbUrl(sender) {
  if (!sender || typeof sender !== 'object') {
    return null;
  }

  return resolveAvatarImageUrl({
    image: sender.avatar_url || sender.avatar || null,
    thumbnail: sender.thumbnail,
    size: 'small',
  });
}

/**
 * Tên hiển thị cho avatar chữ người gửi.
 * @param {Record<string, unknown>|null|undefined} sender
 * @returns {string}
 */
export function chatSenderDisplayName(sender) {
  if (!sender || typeof sender !== 'object') {
    return '';
  }

  return String(
    sender.name
    || sender.fullname
    || sender.full_name
    || sender.display_name
    || sender.username
    || '',
  ).trim();
}
